import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import React, { Component } from "react";
import { SignIn } from "./views/Sign-In/SignIn";
import { AuthenticationService, UserService, VersionService } from "./services/ApiService";
import { Dashboard } from "./views/Dashboard/Dashboard";

import { getLang } from "./i18n/i18n";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: !!localStorage.getItem("token"), // If the token is setup it means that the user authenticate
      errorMessage: ""
    };

    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.circuitBreaker = this.circuitBreaker.bind(this);

    AuthenticationService.circuitBreakerCallback = this.circuitBreaker;
  }

  onLogout() {
    this.setState({ isAuthenticated: false });
  }

  circuitBreaker() {
    if (!localStorage.getItem("lang")) {
      localStorage.setItem("lang", "es");
    }

    const selectedLanguage = localStorage.getItem("lang");
    const lang = getLang(selectedLanguage);

    localStorage.clear();
    this.setState({
      isAuthenticated: false,
      errorMessage: lang["TIMEOUT_ERROR"]
    });
  }

  async handleAuthentication(username, password) {
    try {
      let token = await AuthenticationService.authenticate(username, password);
      let me = await UserService.getMe(token);

      this.saveCredentials(token, me);
      this.setState({ isAuthenticated: true, errorMessage: "", me: me });
    } catch (e) {
      const errorCode = e.response.data.error;
      if (!localStorage.getItem("lang")) {
        localStorage.setItem("lang", "es");
      }

      const selectedLanguage = localStorage.getItem("lang");
      const lang = getLang(selectedLanguage);

      if (errorCode === "INVALID_CREDENTIALS") {
        this.setState({ errorMessage: lang["INVALID_CREDENTIALS_ERROR"] });
      } else {
        this.setState({ errorMessage: lang["GENERAL_ERROR"] });
      }
    }
  }

  saveCredentials(token, me) {
    localStorage.setItem("token", token);
    localStorage.setItem("me", JSON.stringify(me.user));
    localStorage.setItem("decode", JSON.stringify(me));
  }

  async componentDidMount() {
    const version = await VersionService.getVersion();
    localStorage.setItem('api_version', version);
  }
  

  render() {
    if (this.state.isAuthenticated) {
      try {
        let me = JSON.parse(localStorage.getItem("me"));
        return <Dashboard me={me} onLogout={this.onLogout} />;
      } catch (e) {
        console.error(e);
      }
    }

    return (
      <SignIn
        authenticate={this.handleAuthentication}
        errorMessage={this.state.errorMessage}
      />
    );
  }
}

class Root extends Component {
  render() {
    return (
      <div className="App-container">
        <App />
      </div>
    );
  }
}

export default Root;
